import { Button, Dialog } from "@mui/material";
import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSupabaseCallback } from "../../../../server/supabase/hooks";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import { SupabaseSegmentService } from "../../server/supabase-segment-service";
import type { Segment } from "../../types";
import { NewSegmentManagerWrapper } from "../manager-v2/segment-manager-wrapper";

export const ManageDefaultSegmentButton: FC = () => {
  const { t } = useTranslation();
  const dialog = useDialog<Segment | null>();
  const [loading, setLoading] = useState(false);

  const loadSegment = useSupabaseCallback(
    async ({ supabase }) => {
      setLoading(true);

      const { data } = await new SupabaseSegmentService(supabase).getDefaultSegment();

      setLoading(false);

      return dialog.handleOpen(data);
    },
    [dialog],
  );

  return (
    <>
      <Button
        data-analytics-id="segment-set-default-filters"
        loading={loading}
        onClick={() => void loadSegment().catch(console.error)}
        variant="contained"
      >
        {t("Set default filters")}
      </Button>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth maxWidth="md">
        {dialog.data && (
          <NewSegmentManagerWrapper
            segment={dialog.data}
            onClose={dialog.handleClose}
            disabled={loading}
            is_recipient_type={false}
          />
        )}
      </Dialog>
    </>
  );
};
